export class GiftcardModel {
    status: "NEW";
    _id: "5fc5ca810446c4142fce48ba";
    subscriptionId: {};
    amount: 1;
    message: '';
    code: '6043-9628-8072';

}
